import { render, staticRenderFns } from "./jiageshenheListNew.vue?vue&type=template&id=54a24106&scoped=true"
import script from "./jiageshenheListNew.js?vue&type=script&lang=js&external"
export * from "./jiageshenheListNew.js?vue&type=script&lang=js&external"
import style0 from "./jiageshenheListNew.scss?vue&type=style&index=0&id=54a24106&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a24106",
  null
  
)

export default component.exports